/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amino acid`)
};

const es_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aminoácido`)
};

const de_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aminosäure`)
};

const nl_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aminozuur`)
};

const fr_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acide aminé`)
};

const it_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amminoacido`)
};

const pt_br2_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aminoácido`)
};

const pt_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aminoácido`)
};

const ja_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アミノ酸`)
};

const zh_codon_col_aa = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`氨基酸`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_col_aa = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_col_aa(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_col_aa", locale)
	if (locale === "en") return en_codon_col_aa(inputs)
	if (locale === "es") return es_codon_col_aa(inputs)
	if (locale === "de") return de_codon_col_aa(inputs)
	if (locale === "nl") return nl_codon_col_aa(inputs)
	if (locale === "fr") return fr_codon_col_aa(inputs)
	if (locale === "it") return it_codon_col_aa(inputs)
	if (locale === "pt-BR") return pt_br2_codon_col_aa(inputs)
	if (locale === "pt") return pt_codon_col_aa(inputs)
	if (locale === "ja") return ja_codon_col_aa(inputs)
	return zh_codon_col_aa(inputs)
};